import { booleanAttribute, ChangeDetectionStrategy, Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LoadingButtonComponent } from '@tribeauto/ngx-mobilite-material';
import { Router } from '@angular/router';

@Component({
  selector: 'pvmo-error-page',
  imports: [TranslatePipe, LoadingButtonComponent],
  templateUrl: './pvmo-error-page.component.html',
  styleUrl: './pvmo-error-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class PvmoErrorPageComponent {
  private readonly router = inject(Router);

  errorTitle = 'error-title';
  errorMessage = 'error-message';
  reconnectionButton = false;

  @Input({ transform: booleanAttribute }) set tokenExpired(tokenExpired: boolean) {
    if (tokenExpired) {
      this.errorTitle = 'error-expired-title';
      this.errorMessage = 'error-expired-message';
      this.reconnectionButton = true;
    }
  }

  retryLogin(): void {
    void this.router.navigateByUrl('/home');
    window.location.reload();
  }
}
